import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FamilyDocument } from '@/hooks/useDocuments';
import { FileText, ShieldCheck, CreditCard, GraduationCap, Heart, FolderOpen } from 'lucide-react';

interface CategoryFolderCardProps {
  category: 'medical' | 'identity' | 'school' | 'insurance' | 'other';
  documents: FamilyDocument[];
  onClick: () => void;
}

const categoryConfig = {
  medical: {
    label: 'Médical',
    icon: Heart,
    gradient: 'from-red-500/20 to-pink-500/20',
    iconColor: 'text-red-500'
  },
  identity: {
    label: 'Identité',
    icon: ShieldCheck,
    gradient: 'from-blue-500/20 to-cyan-500/20',
    iconColor: 'text-blue-500'
  },
  school: {
    label: 'École',
    icon: GraduationCap,
    gradient: 'from-green-500/20 to-emerald-500/20',
    iconColor: 'text-green-500'
  },
  insurance: {
    label: 'Assurance',
    icon: CreditCard,
    gradient: 'from-orange-500/20 to-yellow-500/20',
    iconColor: 'text-orange-500'
  },
  other: {
    label: 'Autre',
    icon: FolderOpen,
    gradient: 'from-gray-500/20 to-slate-500/20',
    iconColor: 'text-gray-500'
  }
};

export const CategoryFolderCard: React.FC<CategoryFolderCardProps> = ({
  category,
  documents,
  onClick
}) => {
  const config = categoryConfig[category];
  const Icon = config.icon;

  return (
    <Card 
      className="border border-panel bg-panel hover:bg-panel-hover hover:shadow-lg transition-all duration-200 cursor-pointer group"
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex flex-col items-center text-center space-y-4">
          {/* Folder icon with gradient background */}
          <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${config.gradient} flex items-center justify-center group-hover:scale-110 transition-transform duration-200`}>
            <Icon className={`h-8 w-8 ${config.iconColor}`} />
          </div>

          {/* Category name */}
          <div>
            <h3 className="text-lg font-semibold mb-1">{config.label}</h3>
            <p className="text-sm text-muted-foreground">
              {documents.length} document{documents.length > 1 ? 's' : ''}
            </p>
          </div>

        </div>
      </CardContent>
    </Card>
  );
};